// 仅使用登录接口成功响应中的目标地址，二次验证尚未完成时不允许提前跳转。
export const getMobileLoginDestination = (loginResult, mobile) => {
  var _loginResult$retVal;
  if (!mobile || (loginResult === null || loginResult === void 0 ? void 0 : loginResult.result) !== 0) return "";
  const destination = (_loginResult$retVal = loginResult.retVal) === null || _loginResult$retVal === void 0 ? void 0 : _loginResult$retVal.destination;
  return typeof destination === "string" ? destination.trim() : "";
};